import { SxProps, Theme, styled } from "@mui/material";
import { CSSProperties } from "react";
import PurpleLogoSVG from "../../../assets/images/icon-no-text.svg";
import LazoCircularLogoSVG from "../../../assets/images/lazo-circular-icon.svg";
import LazoLogoSVG from "../../../assets/images/logo-lazo.svg";
import WhiteLogoSVG from "../../../assets/images/white-logo.svg";

interface Props {
  styles?: CSSProperties;
  sxClass?: SxProps<Theme>;
}

const StyledImage = styled("img")({});

/**
 * Purple logo without letters.
 */
export const LazoLogoWhiteNoLetters = ({ styles, sxClass }: Props) => {
  return <StyledImage sx={sxClass} style={{ width: "2.5rem", ...styles }} src={WhiteLogoSVG.src} alt="lazo-icon" />;
};

/**
 * White logo without letters.
 */
export const LazoLogoPurpleNoLetters = ({ sxClass, styles }: Props) => {
  return <StyledImage sx={sxClass} style={styles} src={PurpleLogoSVG.src} alt="lazo-icon" />;
};

/**
 * Standard white Lazo logo
 */
export const LazoLogoWhite = ({ sxClass, styles }: Props) => {
  return <StyledImage sx={sxClass} style={styles} src={LazoLogoSVG.src} alt="lazo-icon" />;
};

/**
 * Circular white logo, blue background
 */
export const LazoCircularLogo = ({ sxClass, styles }: Props) => {
  return <StyledImage sx={sxClass} style={styles} src={LazoCircularLogoSVG.src} alt="lazo-icon" />;
};
